"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const utils_1 = require("../../utils");
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: right;
  align-items: center;
  margin-right: 32px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    justify-content: left;
    width: 200px;
  `)};

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-right: 32px;
    justify-content: left;
    max-width: 240px;
  `)};
`;
const ClearButton = (0, react_1.memo)(({ title = i18n_1.Strings.settings.notifications.clear, className, clearAll, iconWidth = 20, iconHeight = 20, selected = clearAll, notificationsExtraData = undefined, identifier = undefined, isPortableDevice = false, }) => {
    const notificationsService = (0, hooks_1.useNotificationsService)();
    const deleteNotification = () => __awaiter(void 0, void 0, void 0, function* () {
        if (notificationsExtraData) {
            const notificationToRemove = (0, utils_1.getSelectedNotificationIDs)(notificationsExtraData);
            notificationToRemove.forEach(id => handleDelete(id));
        }
        if (identifier && identifier > 0) {
            yield handleDelete(identifier);
        }
        else {
            notificationsService === null || notificationsService === void 0 ? void 0 : notificationsService.clearSyncNotification();
        }
    });
    const handleDelete = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield (notificationsService === null || notificationsService === void 0 ? void 0 : notificationsService.delete(id));
    });
    const button = (selected || isPortableDevice) && ((0, jsx_runtime_1.jsxs)(StyledButton, { onClick: deleteNotification, "$clearAll": clearAll, "$selected": selected, "$isPortableDevice": isPortableDevice, "data-e2e": 'StyledButton', children: [(0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Bin, height: iconHeight, width: iconWidth, "data-e2e": 'Icon' }), (0, jsx_runtime_1.jsx)(StyledTitle, { "data-e2e": 'StyledTitle', children: (0, i18n_1.Localized)(title) })] }));
    return (0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'Container', children: button });
});
const StyledButton = (0, styled_components_1.default)(ui_1.FlatButton) `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;

  border: 0;
  padding: 0;

  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  color: ${({ theme }) => theme.textSecondary};

  background-color: ${({ $clearAll, $isPortableDevice, $selected, theme }) => $clearAll
    ? theme.designSystem.background
    : $isPortableDevice
        ? $selected
            ? theme.designSystem.contentBackground
            : theme.designSystem.background
        : theme.designSystem.contentBackground};

  ${({ $clearAll }) => !$clearAll &&
    ui_1.device.tablet((0, styled_components_1.css) `
      margin-right: 37px;
    `)};
`;
const StyledTitle = styled_components_1.default.span `
  margin-top: 3px;
  margin-left: 4px;
  text-transform: uppercase;
  white-space: nowrap;
`;
exports.default = ClearButton;
